// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "psicologa-pistola.firebaseapp.com",
  "projectId": "psicologa-pistola",
  "storageBucket": "psicologa-pistola.appspot.com",
  "messagingSenderId": "550755505590",
  "appId": "1:550755505590:web:c6b642ac5ac49927895d17",
  "apiKey": "AIzaSyDbC9pp_SEI3dFMoF51dy-UKFsew6r3SsE"
};
